import { Link } from 'react-router-dom'
import { useModules, useProjectMaterials } from '../api/queries'
import { Card } from './ui'
import { formatDate } from '../lib/format'

/**
 * Hvad der gik til sagen (docs/DECISIONS.md beslutning 071).
 *
 * <b>Det er hele pointen med sagskoblingen.</b> Forbrug registreres netop for at
 * kunne svare på "hvad blev der brugt her" - står det kun i bevægelseshistorikken
 * under Lager, skal man kende sagens navn for at finde det, og så bliver det
 * aldrig slået op.
 *
 * <b>Kun antal og vare - ingen værdi.</b> Kostprisen står på den enkelte vare for
 * den, der slår op, men en sum på sagen ville være begyndelsen på et
 * økonomimodul, og økonomien ligger et andet sted (beslutning 031 og 046).
 */
export function ProjectMaterialsCard({ projectId }: { projectId: number }) {
  const { data: modules } = useModules()
  const enabled = modules?.some((m) => m.key === 'stock' && m.enabled) ?? false

  const { data } = useProjectMaterials(enabled ? projectId : 0)

  // Er der ikke brugt noget, er kortet stoej. Sagen faar det, saa snart der
  // scannes materialer paa den.
  if (!enabled || !data || data.materials.length === 0) return null

  return (
    <Card title={`Materialer (${data.materials.length})`}>
      <div className="stack" style={{ gap: 2 }}>
        {data.materials.map((material) => (
          <div key={material.itemId} className="row row--between device-row">
            <div style={{ minWidth: 0 }}>
              <div className="small">{material.itemName}</div>
              <div className="tiny muted">
                {material.itemCode} · sidst {formatDate(material.lastUsedAt)}
              </div>
            </div>
            <div
              className="small"
              style={{
                whiteSpace: 'nowrap',
                fontWeight: 600,
                // Et negativt tal betyder, at en fejlscanning er rettet med en
                // modsat bevaegelse. Det skal ses, ikke gemmes.
                color: material.quantity < 0 ? 'var(--danger, #b91c1c)' : undefined
              }}
            >
              {material.quantity.toLocaleString('da-DK', { maximumFractionDigits: 3 })}{' '}
              {material.unit}
            </div>
          </div>
        ))}
      </div>

      <div className="tiny muted" style={{ marginTop: 10 }}>
        Lagt sammen af {data.movementCount === 1 ? '1 registrering' : `${data.movementCount} registreringer`}.{' '}
        <Link to="/stock/scan">Scan flere</Link>
      </div>
    </Card>
  )
}
